import { useEffect, useState } from 'react';

/**
 * Returns the current time, updating once per minute (aligned to the clock).
 * Use to re-evaluate time-sensitive UI such as session expiry without a full page refresh.
 */
export function useMinuteClock(): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const current = new Date();
    const msUntilNextMinute =
      (60 - current.getSeconds()) * 1000 - current.getMilliseconds();

    let interval: ReturnType<typeof setInterval> | null = null;

    const alignTimeout = setTimeout(() => {
      setNow(new Date());
      interval = setInterval(() => {
        setNow(new Date());
      }, 60 * 1000);
    }, msUntilNextMinute);

    return () => {
      clearTimeout(alignTimeout);
      if (interval) clearInterval(interval);
    };
  }, []);

  return now;
}
